/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "loangateway": {
        "nested": {
          "v1alpha1": {
            "nested": {
              "TransactionFailureReason": {
                "fields": {
                  "value": {
                    "type": ".squareup.loangateway.v1alpha1.TransactionFailureReason.Value",
                    "id": 1
                  }
                },
                "nested": {
                  "Value": {
                    "values": {
                      "INSUFFICIENTFUNDS": 0,
                      "CHARGEBACK": 1,
                      "ACCOUNTCLOSED": 2,
                      "INVALIDACCOUNT": 3,
                      "UNKNOWNREASON": 4,
                      "INVALIDCVV": 5,
                      "INVALIDEXPIRATIONDATE": 6,
                      "AVSFAILED": 7,
                      "NETWORKERROR": 8,
                      "CARDDECLINED": 9,
                      "ACCOUNTFROZEN": 10,
                      "DECEASED": 11,
                      "INVALIDROUTING": 12,
                      "PAYMENTSTOPPED": 13,
                      "INCORRECTNUMBER": 14,
                      "FRAUDULENT": 15,
                      "UNAUTHORIZEDDEBIT": 16
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.loangateway?.nested?.v1alpha1?.nested?.TransactionFailureReason && !$root.nested?.squareup?.nested?.loangateway?.nested?.v1alpha1?.nested?.TransactionFailureReason?.nested?.Value) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransactionFailureReason @ squareup/loangateway/v1alpha1/peachapiv1.proto at 4727:1
 */
export const TransactionFailureReason = $root.lookupType('squareup.loangateway.v1alpha1.TransactionFailureReason');
fixType(TransactionFailureReason);
Builder.createAndAttachToType(TransactionFailureReason);
/**
 * SOURCE Value @ squareup/loangateway/v1alpha1/peachapiv1.proto at 4730:3
 */
TransactionFailureReason.Value = $root.lookupEnum('squareup.loangateway.v1alpha1.TransactionFailureReason.Value').values;